import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { Page, Button, Input, alert } from 'equasion-lib';
import { FiChevronLeft } from 'react-icons/fi';
import SharedScanner from '@/lib/shared-coms/SharedScanner';
import { playFailTone, playSuccessTone } from '@/lib/scanning/feedback';
import { operatorFacingMessage } from '@/lib/utils/errorUtils';
import { addToteReturnPath } from '@/lib/pickVerifyShip';
import { toteAddValidation } from './AddTote.validation';
import './AddTote.scss';

function AddTote({ salesOrder, toteAssign, companyId, returnTo }) {
  const navigate = useNavigate();
  const { id: salesOrderId } = salesOrder || {};

  // Back to whichever pick screen opened this one: the standard picking screen, or the Pick → Verify
  // → Ship Pick screen when it passed `returnTo=pick` (see AddTote.data.tsx).
  const returnToPicking = () => navigate(addToteReturnPath(salesOrderId, returnTo));

  const submitToteAssign = async (values, actions, fromScan = false) => {
    const { setSubmitting } = actions || {};
    try {
      const { name } = values;
      const {
        data: { toteAssign: res }
      } = await toteAssign({
        variables: {
          companyId,
          name,
          orderId: salesOrderId
        }
      });
      if (res) {
        if (fromScan) playSuccessTone();
        returnToPicking();
      }
    } catch (e) {
      if (fromScan) playFailTone();
      // Previously `console.log` with no alert import: a missing tote (404), an already-assigned
      // tote (409) or — since totes became optional — a company that turned totes off (403) all
      // left the picker staring at an unchanged screen while still blocked by the picking gate.
      // Every sibling scan screen alerts; so does this one now. The totes-off message is a full
      // sentence naming the setting (see TOTES_DISABLED_MESSAGE in libs/services tote.service.ts),
      // and errorUtils whitelists FORBIDDEN as operator-facing, so it reaches the picker verbatim.
      alert('Error', operatorFacingMessage(e, 'Could not assign that tote'), 4, 'error');
    }
    if (setSubmitting) setSubmitting(false);
  };

  return (
    <Page className="sales-order-pick-scan action-page">
      <div className="action-top-bar">
        <div className="top">
          <Button
            type="secondary"
            iconBefore={<FiChevronLeft />}
            onClick={returnToPicking}
          >
            Back
          </Button>
          <div>Scan Tote</div>
        </div>
      </div>
      <div className="action-page-body">
        <SharedScanner
          alternativeManualEntryTitle="Tote"
          showSerial={false}
          handleScan={({ text }) => submitToteAssign({ name: text }, null, true)}
          alternativeManualEntry={
            <Formik
              initialValues={{ name: '' }}
              validationSchema={toteAddValidation()}
              validateOnBlur={false}
              onSubmit={submitToteAssign}
              enableReinitialize
            >
              {({ isSubmitting }) => (
                <Form className="tote-form">
                  <span>Enter Tote</span>
                  <Input name="name" label="Tote" />
                  <Button type="primary" fullWidth isSubmit disabled={isSubmitting}>
                    Submit
                  </Button>
                </Form>
              )}
            </Formik>
          }
        />
      </div>
    </Page>
  );
}

export default AddTote;
